import React from "react";

export default function TextGradient({
  isBold = false,
  height = 20,
  title = {},
  stop = [],
  width,
  fontSize = "14",
  isCenterItem,
  isDefaultFont = false,
  stroke,
  strokeWidth = 2,
}) {
  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <defs>
        <style>
          {`
         @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Grechen+Fuemen&family=Karla:ital,wght@0,200..800;1,200..800&family=Lobster&family=Londrina+Solid:wght@100;300;400;900&family=Mulish:ital,wght@0,300;1,300&family=Vina+Sans&display=swap');
        `}
        </style>
        <linearGradient id="textGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          {stop.map((item) => {
            return (
              <stop
                key={item.offset}
                offset={item.offset}
                stop-color={item.color}
              />
            );
          })}
        </linearGradient>
      </defs>
      {isCenterItem ? (
        <text
          x="50%"
          y="50%"
          text-anchor="middle"
          dominant-baseline="middle"
          font-size={`${fontSize}px`}
          fill="url(#textGradient)"
          fontFamily={`${isDefaultFont ? "" : `"Londrina Solid", serif`}`}
          font-weight={isBold || strokeWidth ? "bold" : ""}
          stroke={strokeWidth ? "" : stroke || "#490202"} // Màu viền ngoài -->
          stroke-width={strokeWidth} // Độ dày viền -->
          stroke-linejoin="round" // Hình dạng của các góc viền -->
          stroke-linecap="round" // Hình dạng của các điểm đầu và cuối viền -->
        >
          {title}
        </text>
      ) : (
        <text
          x={0}
          y={height}
          font-size={`${fontSize}px`}
          fontFamily={`${isDefaultFont ? "" : `"Londrina Solid", serif`}`}
          fill="url(#textGradient)"
          font-weight={isBold ? "bold" : ""}
        >
          {title}
        </text>
      )}
    </svg>
  );
}
